/*
NOTE: This file uses Swiper as loaded from npm, which means npm is the "package manager" for it.
      To get a more recent version of Swiper, you need to update it like this:
      `ddev npm update`
*/
import { register } from 'swiper/element/bundle';
register();

/*
* NOTE: This is the easiest way to manage sliders that need to be customised beyond what setting parameters on the web component will allow.
*
* init='false' needs to be set on the component, and then customise things below.
* */

// FEATURED ENTRIES SLIDERS
	const featuredEntrySliders = document.querySelectorAll(`[data-entry-type="rowFeaturedEntriesSlider"] swiper-container[init="false"]`);

	console.log(`We ran and we found ${featuredEntrySliders.length} featuredEntrySliders that need custom styles and behaviours.`);

	featuredEntrySliders.forEach(
		featuredEntrySlider => {
			/* The nav buttons need to be external to the Web Component in order to position them OUTSIDE of it... which is a PITA because we have to link *the right* navigation elements to the slider, here's the faff workaround to do that which needs Twig as well.

				<div data-entry-type="rowFeaturedEntriesSlider">
					<swiper-container
						init="false"
						data-controls="theseControls"    <- This class may need to be dynamic on the Twig if there are multiple sliders!
					>
						...
					</swiper-controls>

					<div class="theseControls">        <- This class may need to be dynamic on the Twig if there are multiple sliders!
						<div class="vcaPrev">Prev</div>
						<div class="vcaPagination"></div>
						<div class="vcaNext">Next</div>
					</div>
				</div>
			*/
			let controlLinkString = featuredEntrySlider.dataset.controls;

			let featuredEntrySliderParams = {
				navigation: {
					prevEl: `.${controlLinkString} .vcaPrev`,
					nextEl: `.${controlLinkString} .vcaNext`,
				},
				pagination: {
					el: `.${controlLinkString} .vcaPagination`,
					type: 'bullets',
					clickable: true
				},
				centerInsufficientSlides: true,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					640: {
						slidesPerView: 2,
					},
					960: {
						slidesPerView: 3,
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
				injectStyles: [
					`
						swiper-slide {
							height: auto;
						}
					`
				],
			};

			Object.assign(featuredEntrySlider, featuredEntrySliderParams);
			featuredEntrySlider.initialize();
		}
	);

// Homepage Testimonials
	const testimonialsSlider = document.querySelectorAll(`[data-field-type="testimonials"] swiper-container[init="false"]`);

	console.log(`We ran and we found ${testimonialsSlider.length} testimonialsSlider that need custom styles and behaviours.`);

	testimonialsSlider.forEach(
		featuredEntrySlider => {
			/* The nav buttons need to be external to the Web Component in order to position them OUTSIDE of it... which is a PITA because we have to link *the right* navigation elements to the slider, here's the faff workaround to do that which needs Twig as well.

				<div data-entry-type="rowFeaturedEntriesSlider">
					<swiper-container
						init="false"
						data-controls="theseControls"    <- This class may need to be dynamic on the Twig if there are multiple sliders!
					>
						...
					</swiper-container>

					<div class="theseControls">        <- This class may need to be dynamic on the Twig if there are multiple sliders!
						<div class="vcaPrev">Prev</div>
						<div class="vcaPagination"></div>
						<div class="vcaNext">Next</div>
					</div>
				</div>
			*/
			let controlLinkString = featuredEntrySlider.dataset.controls;

			let featuredEntrySliderParams = {
				navigation: {
					prevEl: `.${controlLinkString} .vcaPrev`,
					nextEl: `.${controlLinkString} .vcaNext`,
				},
				pagination: {
					el: `.${controlLinkString} .vcaPagination`,
					type: 'bullets',
					clickable: true
				},
				centerInsufficientSlides: true,
				slidesPerView: 1,
				spaceBetween: 20,
				injectStyles: [
					`
						swiper-slide {
							height: auto;
						}
					`
				],
			};

			Object.assign(featuredEntrySlider, featuredEntrySliderParams);
			featuredEntrySlider.initialize();
		}
	);

// Timeline
	const timelineSlider = document.querySelectorAll(`.rowTimeline swiper-container[init="false"]`);

	console.log(`We ran and we found ${timelineSlider.length} timelineSlider that need custom styles and behaviours.`);

	timelineSlider.forEach(
		timelineSlider => {
			/* The nav buttons need to be external to the Web Component in order to position them OUTSIDE of it... which is a PITA because we have to link *the right* navigation elements to the slider, here's the faff workaround to do that which needs Twig as well.

				<div data-entry-type="rowFeaturedEntriesSlider">
					<swiper-container
						init="false"
						data-controls="theseControls"    <- This class may need to be dynamic on the Twig if there are multiple sliders!
					>
						...
					</swiper-container>

					<div class="theseControls">        <- This class may need to be dynamic on the Twig if there are multiple sliders!
						<div class="vcaPrev">Prev</div>
						<div class="vcaPagination"></div>
						<div class="vcaNext">Next</div>
					</div>
				</div>
			*/
			let controlLinkString = timelineSlider.dataset.controls;

			let timelineSliderParams = {
				navigation: {
					prevEl: `.${controlLinkString} .vcaPrev`,
					nextEl: `.${controlLinkString} .vcaNext`,
				},
				pagination: {
					el: `.${controlLinkString} .vcaPagination`,
					type: 'bullets',
					clickable: true
				},
				centerInsufficientSlides: true,
				slidesPerView: 1,
				spaceBetween: 25,
				breakpoints: {
					640: {
						slidesPerView: 1.5,
					},
					960: {
						slidesPerView: 2.5,
					},
					1280: {
						slidesPerView: 3,
						spaceBetween: 50,
					},
				},
				injectStyles: [
					`
						swiper-slide {
							height: auto;
						}
					`
				],
			};

			Object.assign(timelineSlider, timelineSliderParams);
			timelineSlider.initialize();
		}
	);

// blockInfoSlider
	const blockInfoSliders = document.querySelectorAll(`[data-entry-type='blockInfoSlider'] swiper-container[init="false"]`);

	console.log(`We ran and we found ${blockInfoSliders.length} blockInfoSlider that need custom styles and behaviours.`);

	blockInfoSliders.forEach(
		blockInfoSlider => {
			/* The nav buttons need to be external to the Web Component in order to position them OUTSIDE of it... which is a PITA because we have to link *the right* navigation elements to the slider, here's the faff workaround to do that which needs Twig as well.

				<div data-entry-type="rowFeaturedEntriesSlider">
					<swiper-container
						init="false"
						data-controls="theseControls"    <- This class may need to be dynamic on the Twig if there are multiple sliders!
					>
						...
					</swiper-container>

					<div class="theseControls">        <- This class may need to be dynamic on the Twig if there are multiple sliders!
						<div class="vcaPrev">Prev</div>
						<div class="vcaPagination"></div>
						<div class="vcaNext">Next</div>
					</div>
				</div>
			*/
			let controlLinkString = blockInfoSlider.dataset.controls;

			let blockInfoSliderParams = {
				navigation: {
					prevEl: `.${controlLinkString} .vcaPrev`,
					nextEl: `.${controlLinkString} .vcaNext`,
				},
				pagination: {
					el: `.${controlLinkString} .vcaPagination`,
					type: 'bullets',
					clickable: true
				},
				centerInsufficientSlides: true,
				slidesPerView: 1,
				injectStyles: [
					`
						swiper-slide {
							height: auto;
						}
					`
				],
			};

			Object.assign(blockInfoSlider, blockInfoSliderParams);
			blockInfoSlider.initialize();
		}
	);

// rowGallerySlider
	const rowGallerySliders = document.querySelectorAll(`[data-entry-type="rowGallerySlider"]`);

	console.log(`We ran and we found ${rowGallerySliders.length} rowGallerySliders that need custom styles and behaviours.`);

	rowGallerySliders.forEach(
		rowGallerySlider => {
			/* THIS ONE IS DIFFERENT because there are actually two sliders in one, so the logic isn't the same as the others */
			let theSwiper           = rowGallerySlider.querySelector('.theSwiper');
			let controlLinkString    = theSwiper.dataset.controls;
			let theThumbnailsSwiper = rowGallerySlider.querySelector(`.${controlLinkString} .theThumbnails`);

			let theThumbnailsSwiperParams = {
				loop: true,
				spaceBetween: 10,
				slidesPerView: 4,
				centerInsufficientSlides: true,
				freeMode: true,
				watchSlidesProgress: true,
				injectStyles: [
					`
						swiper-slide {
							height: auto;
						}
					`
				]
			};

			let theSwiperParams = {
				loop: true,
				spaceBetween: 0,
				navigation: {
					prevEl: `.${controlLinkString} .vcaPrev`,
					nextEl: `.${controlLinkString} .vcaNext`,
				},
				injectStyles: [
					`
						swiper-slide {
							height: auto;
						}
					`
				],
			};

			Object.assign(theThumbnailsSwiper, theThumbnailsSwiperParams);
			Object.assign(theSwiper, theSwiperParams);
			theThumbnailsSwiper.initialize();
			theSwiper.initialize();
		}
	);

// WHO WE WORK WITH
const whoWeWorkWithSliders = document.querySelectorAll(`.whoWeWorkWithList swiper-container[init="false"]`);

console.log(`We ran and we found ${whoWeWorkWithSliders.length} whoWeWorkWithSliders that need custom styles and behaviours.`);

whoWeWorkWithSliders.forEach(
	whoWeWorkWithSlider => {
		let whoWeWorkWithSliderParams = {
			loop: true,
			speed: 6500,
			freeMode: true,
			autoplay: {
				delay: 0,
			},
			slidesPerView: 'auto',
			spaceBetween: 40,
			injectStyles: [
				`
					.swiper-wrapper {
						pointer-events: none;
						transition-timing-function: linear !important;
					}
					::slotted(swiper-slide) {
						height: auto;
						width: min(25cqw, 280px);
					}
				`
			],
		};

		Object.assign(whoWeWorkWithSlider, whoWeWorkWithSliderParams);
		whoWeWorkWithSlider.initialize();
	}
);
